import { RestClient } from './RestClient'
import store from 'src/store'

export class ExpensesClient extends RestClient {
  /**
   * ExpensesClient constructor
   *
   * @constructor
   */
  constructor () {
    super()

    let currentTeam = store.getters.activeTeam
    this.baseUrl = `/teams/${currentTeam.id}/expenses`
  }

  /**
   * Get a list of all expenses for the current company
   *
   * @returns {AxiosPromise}
   */
  list () {
    return this.call('get', this.baseUrl)
  }

  /**
   * Show the specified expenses
   *
   * @param {(...number|number[])} id - Expenses to show
   *
   * @returns {AxiosPromise}
   */
  get (...id) {
    return this.call('get', `${this.baseUrl}/${this.parseAndJoin(id)}`)
  }

  /**
   * Create a new expense
   *
   * @param {Object} data - Expense info
   *
   * @returns {AxiosPromise}
   */
  create (data) {
    return this.call('post', this.baseUrl, data)
  }

  /**
   * Update an existing expense
   *
   * @param {number} expenseId - Expense id
   * @param {Object} data   - Expense info
   *
   * @returns {AxiosPromise}
   */
  update (expenseId, data) {
    return this.call('patch', `${this.baseUrl}/${expenseId}`, data)
  }

  /**
   * Delete the specified expenses
   *
   * @param {(...number|number[])} expenseIds - Expenses which should be deleted
   *
   * @returns {AxiosPromise}
   */
  destroy (...expenseIds) {
    return this.call('delete', `${this.baseUrl}/${this.parseAndJoin(expenseIds)}`)
  }

  /**
   * Attach an document to the specified expense
   *
   * @param {number} expenseId
   * @param {FormData} data
   *
   * @returns {AxiosPromise}
   */
  attachDocument (expenseId, data) {
    return this.call('post', `${this.baseUrl}/${expenseId}/document`, data)
  }

  /**
   * Start an expense export process
   *
   * @param {Object} filters - Export filters
   *
   * @returns {AxiosPromise}
   */
  export (filters = {}) {
    return this.call('post', `${this.baseUrl}/export`, filters)
  }

  /**
   * Commit an expense
   *
   * @param {number} expenseId - Expense id
   * @return {AxiosPromise}
   */
  commit (expenseId) {
    return this.call('post', `${this.baseUrl}/${expenseId}/commit`)
  }

  /**
   * Add a payment to an expense
   *
   * @param {number} expenseId - Expense id
   * @param {Object} paymentData - Payment data
   *
   * @returns {AxiosPromise}
   */
  addPayment (expenseId, paymentData) {
    return this.call('post', `${this.baseUrl}/${expenseId}/payments`, paymentData)
  }

  /**
   * Update an existing payment
   *
   * @param {number} expenseId - Expense id
   * @param {number} paymentId - Payment id
   * @param {Object} paymentData - Payment data
   *
   * @returns {AxiosPromise}
   */
  updatePayment (expenseId, paymentId, paymentData) {
    return this.call('patch', `${this.baseUrl}/${expenseId}/payments/${paymentId}`, paymentData)
  }

  /**
   * Delete the specified payments
   *
   * @param {number} expenseId - Expense id
   * @param {numer} paymentId - Payment which should be deleted
   *
   * @returns {AxiosPromise}
   */
  destroyPayment (expenseId, paymentId) {
    return this.call('delete', `${this.baseUrl}/${expenseId}/payments/${paymentId}`)
  }
}
